@if (!fileId) {
    <button nz-button nzType="dashed" nzBlock (click)="browse.emit()" type="button">
        <span nz-icon nzType="google"></span> Browse Drive
    </button>
} @else {
    <div class="selected-file-card">
        
        <div class="file-info-main">
            <div class="icon-and-text">
                <span nz-icon [nzType]="iconType" [nzTheme]="iconTheme" [nzTwotoneColor]="iconColor" class="file-icon"></span>
                <div class="file-text">
                    <div class="file-name" [title]="fileName">{{ fileName }}</div>
                    <a [href]="fileLink" target="_blank" class="file-link">
                        Open in Drive <span nz-icon nzType="select"></span>
                    </a>
                    <div>
                        <a target="_parent" class="file-link" (click)="copyToClipboard(fileLink, 'File Link')" nz-tooltip nzTooltipTitle="Copy Link">
                            Copy Drive Link <span nz-icon nzType="copy" class="copy-icon"></span>
                        </a>
                    </div>
                    
                </div>
            </div>
            
            <div class="file-actions">
                @if (canEdit) {
                    <button nz-button nzType="default" nzSize="small" (click)="browse.emit()" type="button">
                        <span nz-icon nzType="swap"></span> Change
                    </button>
                    @if (showRemove) {
                        <button nz-button nzType="text" nzDanger nzSize="small" (click)="remove.emit()" type="button">
                            Remove
                        </button>
                    }
                }
            </div>
        </div>

        @if (showMetadata) {
            <div class="file-meta">
                <div class="meta-toggle" (click)="toggleMetadata()">
                    <span class="meta-toggle-text">Details</span>
                    <span nz-icon [nzType]="isMetadataExpanded ? 'up' : 'down'"></span>
                </div>
                
                @if (isMetadataExpanded) {
                    <div class="meta-content">
                        <div class="meta-item">
                            <span class="meta-label">File ID:</span>
                            <span class="meta-value" [title]="fileId">{{ fileId }}</span>
                            <span nz-icon nzType="copy" class="copy-icon" nz-tooltip nzTooltipTitle="Copy ID" 
                                (click)="copyToClipboard(fileId, 'File ID')"></span>
                        </div>
                        
                        @if (folderId) {
                            <div class="meta-item">
                                <span class="meta-label">Folder ID:</span>
                                <span class="meta-value" [title]="folderId">{{ folderId }}</span>
                                <span nz-icon nzType="copy" class="copy-icon" nz-tooltip nzTooltipTitle="Copy Folder ID" 
                                    (click)="copyToClipboard(folderId, 'Folder ID')"></span>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
}